export default __webpack_public_path__ + "static/LeituraTwo-RomanItalic-e36e72982e407f0f4235be87dd5633d6.woff2";